import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import { useAuthContext } from '../Auth/context';
import Logo from '../assets/img/Kwenda-Logo.svg';

const Header = ({ selectCurrency }) => {
  const [toggleMenu, setToggleMenu] = useState(false);

  const { state, actions } = useAuthContext();

  return (
    <>
      <div className='header' id="header">
        <Link to='../'>
          <img className="logo" alt="Kwenda Logo" src={Logo} />
        </Link>
        <nav>
          <ul>
            <li><Link to="../about">عن كويندا</Link></li>
            <li><Link to="../faqs">أسئلة متكررة</Link></li>
            <li className="book-now"><Link to="../">إحجز الآن</Link></li>
          </ul>
        </nav>

        <div className="spacer"></div>

        <nav>
          {
            !state.loggedIn && !state.logged ?
              <ul>
                <li><Link to="../login">تسجيل الدخول</Link></li>
                <li><Link to="../signup">إنشاء حساب</Link></li>
              </ul>
              :
              <ul>
                <li className="clickable"><Link to="../profile">{state.user.fullName || 'حساب المستخدم'}</Link></li>
                <li className="clickable"><p onClick={actions.logout}>تسجيل الخروج</p></li>
              </ul>
          }
        </nav>

        <div onClick={() => setToggleMenu(!toggleMenu)} >
          <span className="iconify web_hidden menu_icon" data-icon="fa-solid:bars"></span>
        </div>
      </div>

      <div className={toggleMenu ? 'mobile-menu-container shown' : 'mobile-menu-container'}>
        <ul>
          <li><Link to="../about">عن كويندا</Link></li>
          <li><Link to="../faqs">أسئلة متكررة</Link></li>
          <li><Link to="../">إحجز الآن</Link></li>
          {
            !state.jwt ? <div className='mobile-nav-separator'>
              <li><Link to="../login">تسجبل الدخول</Link></li>
              <li><Link to="../signup">إنشاء حساب</Link></li>
            </div>
              : <div className='mobile-nav-separator'>
                <li className="clickable"><Link to="../profile">{state.user.fullName || 'حساب المستخدم'}</Link></li>
                <li><p onClick={actions.logout}>تسجبل الخروج</p></li>
              </div>
          }
        </ul>
      </div>
    </>
  );
};

export default Header;